/**
 * useSession — React Query hook สำหรับ Better Auth session
 *
 * Returns:
 *   isLoading: true ระหว่าง fetch
 *   user:     null = ยังไม่ login, else SessionUser
 *   refetch:  force refresh
 */

import { useQuery } from '@tanstack/react-query';
import { getSession, type SessionData } from './auth';

export function useSession() {
  const q = useQuery({
    queryKey: ['session'],
    queryFn: getSession,
    staleTime: 5 * 60 * 1000, // 5 min
    retry: false,
  });
  return {
    isLoading: q.isLoading,
    user: q.data?.user ?? null,
    session: q.data?.session ?? null,
    refetch: q.refetch,
    raw: q.data as SessionData | null | undefined,
  };
}
